<template>
  <div>
    <vue-headful :title="title" description="Description goes here" />
    <div class="question-library-section">
      <!-- TOP SECTION -->
      <div class="top-section white">
        <div class="container-fliud top-container">
          <div class="row">
            <div
              class="col-12 d-flex justify-content-between align-items-center"
            >
              <!-- LEFT -->
              <div class="left d-flex justify-content-start align-items-center">
                <!-- ASSESSMENT INFO -->
                <div class="assessment-info">
                  <div class="title brand_navy font-weight-bold">
                    Add Questions
                  </div>
                  <div class="duration color_grey_dark">
                    {{ getAssessmentTitle }}
                  </div>
                </div>
              </div>
              <!-- RIGHT -->
              <div class="right">
                <!-- AVATAR ICON -->
                <div class="avatar go-back border_grey_light_bg pointer">
                  <router-link :to="{ name: route_link }">
                    <span
                      class="icon-decline brand_navy flex-center font-17"
                    ></span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- BOTTOM SECTION -->
      <div class="bottom-section position-relative">
        <!-- LEFT -->
        <div class="left brand_navy_bg d-none d-md-block" ref="sideBar">
          <SidebarTopicList
            @topicSelection="handleTopicSelection"
          ></SidebarTopicList>
        </div>

        <!-- RIGHT -->
        <div class="right position-relative" ref="questionBar">
          <!-- TOP SECTION -->
          <div class="container">
            <div class="row">
              <div class="col-12 px-sm-4">
                <TopicHolder :title="topic_title"></TopicHolder>

                <AuthAlertCard
                  v-if="alert.show"
                  :alert_type="alert.type"
                  :alert_msg="alert.msg"
                  class="mb-4"
                />

                <template v-if="fetchingQuestions" name="fade" mode="out-in">
                  <div class="pt-5"></div>
                  <div
                    class="loader d-flex justify-content-center align-items-center my-5 border_grey_dark"
                  >
                    <div
                      class="icon-dotted-roller font-27 mr-2 animate row"
                    ></div>
                    <div class="font-16">Fetching ...</div>
                  </div>
                </template>

                <transition v-else name="fade" mode="out-in">
                  <component
                    v-if="in_view === 'ContentInfo'"
                    :homework_id="homework.id"
                    @selectedQuestion="handleQuestionSelection"
                    @removeQuestion="removeQuestion"
                    :questions="questions || []"
                    :is="in_view"
                  ></component>
                  <component v-else :is="in_view"></component>
                </transition>
              </div>
            </div>
          </div>

          <!-- BOTTOM SECTION -->
          <div class="bottom-section white">
            <div class="container">
              <div class="row">
                <div
                  class="col-12 d-flex justify-content-between align-items-center nowrap"
                >
                  <div
                    class="selections d-flex flex-column justify-content-center align-items-center"
                  >
                    <div class="count color_text font-weight-bold mb-1">
                      {{ total_question_count }}
                    </div>
                    <div class="text text-uppercase font-12 color_text">
                      Questions Selected
                    </div>
                  </div>

                  <button
                    :disabled="total_question_count === 0"
                    ref="attachBtn"
                    @click="attachQuestions"
                    class="btn btn-md btn-accent brand_navy font-weight-bold"
                  >
                    Add to
                    {{ getAssessmentType ? getAssessmentType : "Assessment" }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  bgColorSetter,
  capitalizeFirstLetter,
  persistToLocal,
  purgeFromLocal,
} from "@/scripts/utilities";
import { mapActions, mapMutations, mapGetters } from "vuex";
import SidebarTopicList from "@/components/classComps/assessment/SidebarTopicList";
import TopicHolder from "@/components/classComps/assessment/TopicHolder";
import DefaultInfo from "@/components/classComps/assessment/DefaultInfo";
import AuthAlertCard from "@/components/globalComps/AuthComps/AuthAlertCard";
import ContentInfo from "@/components/classComps/assessment/ContentInfo";

export default {
  name: "QuestionLibrary",

  components: {
    SidebarTopicList,
    AuthAlertCard,
    TopicHolder,
    DefaultInfo,
    ContentInfo,
  },

  computed: {
    ...mapGetters(["getCurrentlySelectHomework"]),

    getAssessmentType() {
      return JSON.parse(localStorage.homework).tag;
    },

    getAssessmentTitle() {
      return JSON.parse(localStorage.homework).title;
    },
  },

  data() {
    return {
      account_type: null,
      title: null,
      in_view: "ContentInfo",
      route_link: "",
      questions: [],
      homework: {},
      fetchingQuestions: true,
      total_question_count: 0,
      topic_title: "",
      unique_question_identifier: "",
      alert: {
        show: false,
        type: "",
        msg: "",
      },
      all_indexes: [],
    };
  },

  created() {
    this.$bus.$on("switchToTopicView", this.toggleSidebar);

    this.$bus.$on("switchToQuestionView", () => {
      console.log("Question");
      this.toggleQuestionView();
    });
  },

  mounted() {
    bgColorSetter("#f0f0f0");
    this.getAccountType();

    if (this.getCurrentlySelectHomework === null)
      this.$router.push({
        name: this.redirect_url,
      });

    this.homework = this.getCurrentlySelectHomework;
    this.unique_question_identifier = `questions_${this.homework.id}`;
    // console.log(this.unique_question_identifier);

    if (localStorage.getItem(this.unique_question_identifier)) {
      this.total_question_count =
        JSON.parse(localStorage.getItem(this.unique_question_identifier))
          .length || 0;
    } else this.total_question_count = 0;
  },

  methods: {
    ...mapMutations(["SET_CURRENT_HOMEWORK"]),
    ...mapActions(["getTopicQuestions", "addQuestionsToHomework"]),

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
      let account_title = capitalizeFirstLetter(this.account_type);
      this.title = `Question Library | ${account_title}`;

      if (this.account_type === "school")
        this.route_link = "ManageSchoolAssessment";
      else if (this.account_type === "teacher")
        this.route_link = "ManageTeacherAssessment";
    },

    toggleSidebar() {
      let sidebar = this.$refs.sideBar;
      if (sidebar.classList.contains("d-none")) {
        sidebar.classList.remove("d-none");
      } else {
        sidebar.classList.add("d-none");
      }
    },

    toggleQuestionView() {
      if (window.innerWidth <= 768) this.toggleSidebar();
    },

    handleQuestionSelection(item) {
      console.log("push to local", item);
      // this.pushToLocal(item);
      let action = persistToLocal(
        this.unique_question_identifier,
        item.question_id,
        true
      );
      if (action.status) this.total_question_count = action.length;
      else this.total_question_count = action.length;
    },

    removeQuestion(item) {
      // this.removeFromLocal(item);
      let action = purgeFromLocal(
        this.unique_question_identifier,
        item.question_id,
        true
      );

      if (action.status) this.total_question_count = action.length;
      else this.total_question_count = action.length;
    },

    handleQuestions(questions) {
      this.questions = questions;
    },

    handleTopicSelection(topic) {
      if (topic) {
        this.topic_title = topic.title;
        this.fetchingQuestions = true;
        this.in_view = "";
        this.fetchQuestionByTopic({
          global_class_id: JSON.parse(localStorage.homework).global_class_id,
          subject_id: topic.subject_id,
          topic_id: topic.topic_id,
        });
      } else {
        this.fetchingQuestions = false;
        this.in_view = "DefaultInfo";
      }
    },

    fetchQuestionByTopic({ global_class_id, subject_id, topic_id }) {
      this.toggleQuestionView();

      this.getTopicQuestions({
        global_class_id,
        subject_id,
        topic_id,
      })
        .then((res) => {
          this.fetchingQuestions = false;
          if (res.code === 200) {
            console.log("fetched data", res);
            this.in_view = "ContentInfo";
            this.questions = res.data;
            console.log(this.questions);
          } else {
            console.log(res.message);
            if (res.code === 406) this.in_view = "DefaultInfo";
          }
        })
        .catch((err) => {
          this.fetchingQuestions = false;
          console.log(err);
          this.showAlert("Ooop.. an error occured, please try again");
        });
    },

    attachQuestions() {
      this.$refs.attachBtn.disabled = true;
      this.$refs.attachBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>ATTACHING ...';

      let questions = JSON.parse(
        localStorage.getItem(this.unique_question_identifier)
      );
      let data = {
        questions,
        class_id: this.homework.global_class_id,
        subject_id: this.homework.subject_id,
      };

      this.addQuestionsToHomework({
        homework_id: this.homework.id,
        data: data,
      })
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            console.log(res.message);
            this.showAlert(res.message, "success");
            // update the total conunt of questions attached to this homework in the localstorag
            let homework_content = JSON.parse(localStorage.homework);
            homework_content.questionCount = res.data.length;
            localStorage.setItem("homework", JSON.stringify(homework_content));
            this.SET_CURRENT_HOMEWORK(homework_content);

            setTimeout(() => {
              // localStorage.removeItem("questions"); // don't remove once it has been pushed

              this.$router.push({
                name:
                  this.account_type === "school"
                    ? "ManageSchoolAssessment"
                    : "ManageTeacherAssessment",
                query: {
                  action: "populated",
                  assessment_id: homework_content.id,
                },
              });
            }, 2000);
          } else {
            this.showAlert(res.message);
          }

          this.$refs.attachBtn.disabled = false;
          this.$refs.attachBtn.innerText = "Attach Question";
        })
        .catch((err) => {
          this.showAlert("Ooop.. an error occured, please try again");
          console.log(err);
          this.$refs.attachBtn.disabled = false;
          this.$refs.attachBtn.innerText = "Attach Question";
        });
    },

    showAlert(msg, type = "error") {
      this.alert = {
        show: true,
        type: type,
        msg: msg,
      };

      setTimeout(() => {
        this.alert = {
          show: false,
          type: "",
          msg: "",
        };
      }, 5000);
    },
  },
};
</script>

<style lang="scss" scoped>
.question-library-section {
  .top-section {
    position: fixed;
    z-index: 9;
    width: 100%;
    padding: 11px 0px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);

    @include breakpoint_max(md) {
      padding: 9px 0px;
    }

    .top-container {
      padding: 0 30px;

      @include breakpoint_max(sm) {
        padding: 0 15px;
      }
    }

    .left {
      .go-back {
        margin-right: 20px;
        font-size: 20px;

        @include breakpoint_max(lg) {
          font-size: 18px;
        }

        @include breakpoint_max(md) {
          margin-right: 10px;
          font-size: 16px;
        }

        @include breakpoint_max(sm) {
          margin-right: 8px;
          font-size: 14px;
        }
      }

      .title {
        font-size: 15.5px;

        @include breakpoint_max(sm) {
          font-size: 13px;
        }

        @include breakpoint_max(xs) {
          font-size: 11.5px;
        }
      }

      .duration {
        font-size: 14px;

        @include breakpoint_max(md) {
          font-size: 13px;
        }

        @include breakpoint_max(sm) {
          font-size: 12px;
        }

        @include breakpoint_max(xs) {
          font-size: 11px;
        }
      }
    }
  }

  .bottom-section {
    @include flex_row_between_wrap;
    align-items: flex-start;
    width: 100%;

    .left {
      position: fixed;
      z-index: 1;
      width: 32%;
      height: 94vh; //91.3vh;
      bottom: 0;
      overflow-y: auto;

      @include breakpoint_max(md) {
        width: 100%;
      }
    }

    .right {
      width: 68%;
      height: 81.9vh;
      left: 32%;

      @include breakpoint_max(md) {
        width: 100%;
        left: 0;
      }

      .bottom-section {
        position: fixed;
        width: 68%;
        padding: 10px 0px;
        bottom: 0;

        @include breakpoint_max(sm) {
          padding: 7px 0px;
        }

        .selections {
          .count {
            font-size: 18px;
            font-weight: bold;

            @include breakpoint_max(md) {
              font-weight: 600;
              font-size: 15px;
            }

            @include breakpoint_max(sm) {
              margin-bottom: 2px !important;
              font-size: 14px;
            }

            @include breakpoint_max(xs) {
              font-size: 13px;
            }
          }

          .text {
            @include breakpoint_max(sm) {
              font-size: 11px !important;
            }

            @include breakpoint_max(xs) {
              font-size: 10.5px !important;
            }
          }
        }

        @include breakpoint_max(md) {
          width: 100%;

          .btn {
            font-size: 10px;
            @include breakpoint_max(sm) {
              padding: 9px 18px !important;
              font-size: 9px !important;
            }
          }
        }
      }
    }
  }
}
</style>
